import { UseFormSetValue } from 'react-hook-form';

import {
  CONTRACT_TYPE,
  RENTAL_AGREEMENT,
  TYPE_OF_TAX,
} from '../../../../shared/constants';
import { IListingDetailForm } from '../ListingDetailForm.types';

export const getTypeOfTaxOptions = (
  values: IListingDetailForm,
  setValue: UseFormSetValue<IListingDetailForm>,
) => {
  if (values?.contract_type?.value === CONTRACT_TYPE['3+2'].value) {
    return [
      {
        label: TYPE_OF_TAX.WITH_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITH_FLAT_TAX.value,
      },
    ];
  } else if (
    values?.contract_type?.value === CONTRACT_TYPE.TEMPORARY.value &&
    values?.rental_agreement?.value === RENTAL_AGREEMENT.AGREED_FEE.value
  ) {
    return [
      {
        label: TYPE_OF_TAX.WITH_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITH_FLAT_TAX.value,
      },
    ];
  } else if (
    values?.contract_type?.value === CONTRACT_TYPE.TEMPORARY_STUDENT.value
  ) {
    return [
      {
        label: TYPE_OF_TAX.WITH_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITH_FLAT_TAX.value,
      },
    ];
  } else if (
    values?.contract_type?.value === CONTRACT_TYPE.TEMPORARY_RENT_TO_RENT.value
  ) {
    if (
      values?.contract_tax_type_flat?.value === TYPE_OF_TAX.WITH_FLAT_TAX.value
    ) {
      setValue('contract_tax_type_flat', null);
    }
    return [
      {
        label: TYPE_OF_TAX.WITHOUT_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITHOUT_FLAT_TAX.value,
      },
    ];
  } else if (
    values?.rental_agreement?.value === RENTAL_AGREEMENT.AGREED_FEE.value
  ) {
    return [
      {
        label: TYPE_OF_TAX.WITH_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITH_FLAT_TAX.value,
      },
    ];
  } else {
    return [
      {
        label: TYPE_OF_TAX.WITHOUT_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITHOUT_FLAT_TAX.value,
      },
      {
        label: TYPE_OF_TAX.WITH_FLAT_TAX.label,
        value: TYPE_OF_TAX.WITH_FLAT_TAX.value,
      },
    ];
  }
};
